'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weekFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/weekFromNow.js
// module id = 387
// module chunks = 1